import React, { useState, useEffect } from 'react';
import { h1, h2, h3, h4 } from '../../assets/index';
import '../../styles/FeeStructure.css';
import { getFeesStructure } from '../../services/getAllApi';
import { hostelimg1, hostelimg2, hostelimg3, hostelimg4, hostelimg5, hostelimg6 } from '../../assets'

// Add this to your CSS file
const style = document.createElement('style');
style.textContent = `
  body {
    overflow-x: hidden;
  }
  @keyframes fadeIn {
    from { opacity: 0; }
    to { opacity: 1; }
  }
  @keyframes slideIn {
    from { transform: translateX(-100%); opacity: 0; }
    to { transform: translateX(0); opacity: 1; }
  }
  @keyframes slideUp {
    from { transform: translateY(20px); opacity: 0; }
    to { transform: translateY(0); opacity: 1; }
  }
`;
document.head.appendChild(style);

const FeeStructure = () => {
  const [feesData, setFeesData] = useState([]);

  useEffect(() => {
    getFeesStructure().then((res) => {

      if (res.status === 200) {
        setFeesData(res.data);
      }
    });
  }, []);

  return (
    <div >
      {/* Rest of your code exactly as is */}
      <div className="p-2 scale-95">
        <div className="w-96 max-w-[100px] bg-orange-500 h-1 mx-0 my-5 relative top-3 left-8 sm:left-16 md:left-24 lg:left-32 xl:left-36"></div>

        <p className="text-orange-500 font-semibold text-2xl sm:text-3xl md:text-4xl relative -top-1 left-6 sm:left-14 md:left-20 lg:left-28 xl:left-32 mx-0 px-4">
          Fees Structure
        </p>

        <div className="w-full h-[3rem] my-8 bg-orange-500 flex items-center justify-center">
          <p className="text-white text-[1.2rem] xs:xl ">
            FULL FEES PAYMENT STRUCTURE
          </p>
        </div>

        <div className="overflow-hidden rounded-xl shadow-lg relative bottom-8 p-8 ">
          <table className="w-full table-fixed text-center">
            <thead className="h-[6rem]">
              <tr className="bg-gray-200">
                <th className="w-1/3 p-2 border-b border-r border-black">Particular</th>
                <th className="w-1/3 p-2 border-b border-r border-black">Tuition Fee Structure <p className="font-normal">(Without Hostel)</p></th>
                <th className="w-1/3 p-2 border-b border-black">Tuition Fee Structure <p className="font-normal">(With Hostel)</p></th>
              </tr>
            </thead>
            <tbody>
              {feesData && feesData.length > 0 ?
                feesData.filter(fees => fees.particular !== "Program Duration").map((fees, index) =>
                  fees.particular === "Total Fees" ? (
                    <tr key={index} className="text-white bg-purple-950">
                      <td className="p-2 font-bold border-r border-black">Total Fees</td>
                      <td className="p-2 font-bold border-r border-black">Rs. {fees.without_hostel}</td>
                      <td className="p-2 font-bold">Rs. {fees.with_hostel}</td>
                    </tr>
                  ) : (
                    <tr key={index}>
                      <td className="p-2 border-b border-r border-black">{fees.particular}</td>
                      <td className="p-2 border-b border-r border-black">Rs. {fees.without_hostel}</td>
                      <td className="p-2 border-b border-black">Rs. {fees.with_hostel}</td>
                    </tr>
                  )
                ) :
                "Loading"
              }
            </tbody>
          </table>
        </div>

        {/* Registration Fee, First Installment, Second Installment */}
        <div className="text-center">
          <p>
            Registration fee Rs. {feesData.find(fee => fee.particular === "Registration Fees")?.with_hostel || '0'} (non-refundable)
          </p>
          <div className="border-b border-dotted border-gray-400 w-[60rem] mx-auto my-2"></div>

          <p>
            First Installment Rs. {feesData.find(fee => fee.particular === "Tuition Fees 1st Year")?.without_hostel || '0'} (At the time of admission)
          </p>
          <div className="border-b border-dotted border-gray-400 w-[60rem] mx-auto my-2"></div>

          <p>
            Second Installment Rs. {feesData.find(fee => fee.particular === "Tuition Fees 2nd Year")?.without_hostel || '0'} (Start of Third semester)
          </p>
          <div className="border-b border-dotted border-black w-[60rem] mx-auto my-2"></div>
        </div>
      </div>

      <div className="relative -top-[2rem]">
        <div className="w-96 max-w-[100px] bg-orange-500 h-1 mx-0 my-5 relative top-3 left-8 sm:left-16 md:left-24 lg:left-32 xl:left-36"></div>

        <p className="text-orange-500 font-semibold text-2xl sm:text-3xl md:text-4xl relative -top-1 left-6 sm:left-14 md:left-20 lg:left-28 xl:left-32 mx-0 px-4">
          Educational Loan
        </p>

        <p className="text-center text-2xl sm:text-3xl font-bold text-orange-500 my-8 sm:my-12">
          We Accept :-
        </p>

        <div className="flex flex-wrap lg:flex-nowrap justify-center lg:justify-between gap-4 px-4 sm:px-6 md:px-8">
          <img src={require("../../assets/Payment icon/Paytm.png")} className="h-12 sm:h-15 lg:h-16 w-[7rem] lg:w-28" alt="Paytm" />
          <img src={require("../../assets/Payment icon/Gpay.png")} className="h-12 sm:h-20 lg:h-16 w-[7rem] lg:w-28" alt="GPay" />
          <img src={require("../../assets/Payment icon/bhim.png")} className="h-12 sm:h-20 lg:h-16 w-[7rem] lg:w-28" alt="BHIM" />
          <img src={require("../../assets/Payment icon/SBI.png")} className="h-12 sm:h-20 lg:h-16 w-[7rem] lg:w-28" alt="SBI" />
          <img src={require("../../assets/Payment icon/Jio.png")} className="h-12 sm:h-20 lg:h-16 w-[7rem] lg:w-28" alt="Jio" />
          <img src={require("../../assets/Payment icon/PhonP.png")} className="h-12 sm:h-20 lg:h-16 w-[7rem] lg:w-28" alt="PhonePe" />
          <img src={require("../../assets/Payment icon/Paypal.png")} className="h-12 sm:h-20 lg:h-16 w-[7rem] lg:w-28" alt="PayPal" />
          <img src={require("../../assets/Payment icon/Mastercard.png")} className="h-12 sm:h-20 lg:h-16 w-[7rem] lg:w-28" alt="Mastercard" />
          <img src={require("../../assets/Payment icon/Maestro.png")} className="h-12 sm:h-20 lg:h-16 w-[7rem] lg:w-28" alt="Maestro" />
          <img src={require("../../assets/Payment icon/Amrican xpres.png")} className="h-12 sm:h-20 lg:h-16 w-[7rem] lg:w-28" alt="American Express" />
        </div>

        <div className="w-full h-auto sm:h-[3.4rem] relative mt-10 my-7 bg-orange-700 flex items-center justify-center shadow-lg text-center py-3 sm:py-0 scale-95">
          <p className="text-white text-xl sm:text-2xl font-bold px-4 relative bottom-2">
            <span className="mx-auto -my-2 relative bottom-1 right-3 text-3xl sm:text-4xl">.</span>
            Option to avail a 100% fees via education loan facility
            <span className="mx-auto -my-2 relative bottom-1 left-4 text-3xl sm:text-4xl">.</span>
          </p>
        </div>

        <ul className="text-center px-4 sm:px-0">
          <li className="flex flex-col sm:flex-row items-center mb-6">
            <span className="text-3xl sm:text-5xl text-orange-500 sm:mr-4 relative sm:bottom-[0.7rem] md:bottom-[1rem] lg:left-[25rem] lg:bottom-4">.</span>
            <span className="text-sm sm:text-base md:text-lg relative lg:left-[25rem]">It can be revised as per institutional norms.</span>
          </li>

          <li className="flex flex-col sm:flex-row items-center">
            <span className="text-3xl sm:text-5xl text-orange-500 sm:mr-4 relative sm:bottom-[1rem] md:bottom-[1.5rem] lg:left-[25rem] lg:bottom-7">.</span>
            <div className="text-left">
              <span className="block text-sm sm:text-base md:text-lg relative lg:left-[25rem]">
                The student can also pay the amount in installments (3–12 months maximum)
              </span>
              <p className="mt-2 text-xs sm:text-sm md:text-base relative lg:left-[25rem]">
                (Any applicable interest will be paid by students.)
              </p>
            </div>
          </li>
        </ul>
      </div>

      <div className="relative top-[10rem] " style={{ marginBottom: "4rem" }}>
        <div className="relative bottom-[10rem]">
          <div className="block lg:flex">
            {/* Left Section: Hostel Fee Details */}
            <div>
              <div className="w-96 max-w-[100px] bg-orange-500 h-1 mx-0 my-5 relative top-3 left-8 sm:left-16 md:left-24 lg:left-32 xl:left-36 animate-[slideIn_0.5s_ease-out]"></div>

              <p className="text-orange-500 font-semibold text-2xl sm:text-3xl md:text-4xl relative -top-1 left-6 sm:left-14 md:left-20 lg:left-28 xl:left-32 mx-0 px-4 animate-[fadeIn_0.8s_ease-out]">
                Hostel Fee
              </p>

              <p className="text-center lg:text-left lg:relative lg:left-[15rem] mt-5 lg:mt-0 lg:top-8 animate-[fadeIn_1s_ease-out]">
                What Are Included In This Hostel Fee Structure
              </p>

              <div className="mx-auto w-fit lg:mx-0 lg:relative lg:left-[15rem] mt-6 lg:mt-0 lg:top-14 font-bold text-white animate-[slideUp_0.8s_ease-out]">
                <div className="w-[20rem] h-15 bg-orange-600 text-center hover:bg-orange-700 transition-colors duration-300">
                  <span className="text-xl sm:text-2xl px-3 py-2">
                    Security Amount: Rs 3000/-
                  </span>
                </div>
              </div>
            </div>

            {/* Right Section: Image Gallery */}
            <div className="relative lg:left-[25rem] lg:top-11 w-full lg:w-[43rem] mt-8 lg:mt-0 animate-[fadeIn_1.5s_ease-out]">
              <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-3 gap-4">
                {/* Image 1 */}
                <div className="relative group overflow-hidden">
                  <img
                    src={hostelimg1}
                    alt="Hostel View 1"
                    className="w-full h-auto transition-transform duration-300 group-hover:scale-110"
                  />
                  <div className="absolute inset-0 bg-black/40 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-center justify-center text-white text-lg font-semibold">
                    Hostel Room
                  </div>
                </div>

                {/* Image 2 */}
                <div className="relative group overflow-hidden">
                  <img
                    src={hostelimg2}
                    alt="Hostel View 2"
                    className="w-full h-auto transition-transform duration-300 group-hover:scale-110"
                  />
                  <div className="absolute inset-0 bg-black/40 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-center justify-center text-white text-lg font-semibold">
                    Dining Area
                  </div>
                </div>

                {/* Image 3 */}
                <div className="relative group overflow-hidden">
                  <img
                    src={hostelimg3}
                    alt="Hostel View 3"
                    className="w-full h-auto transition-transform duration-300 group-hover:scale-110"
                  />
                  <div className="absolute inset-0 bg-black/40 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-center justify-center text-white text-lg font-semibold">
                    Common Hall
                  </div>
                </div>

                {/* Image 4 */}
                <div className="relative group overflow-hidden">
                  <img
                    src={hostelimg4}
                    alt="Hostel View 4"
                    className="w-full h-auto transition-transform duration-300 group-hover:scale-110"
                  />
                  <div className="absolute inset-0 bg-black/40 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-center justify-center text-white text-lg font-semibold">
                    Study Area
                  </div>
                </div>

                <div className="relative group overflow-hidden">
                  <img
                    src={hostelimg5}
                    alt="Hostel View 4"
                    className="w-full h-auto transition-transform duration-300 group-hover:scale-110"
                  />
                  <div className="absolute inset-0 bg-black/40 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-center justify-center text-white text-lg font-semibold">
                    Room Entry
                  </div>
                </div>

                <div className="relative group overflow-hidden">
                  <img
                    src={hostelimg6}
                    alt="Hostel View 4"
                    className="w-full h-auto transition-transform duration-300 group-hover:scale-110"
                  />
                  <div className="absolute inset-0 bg-black/40 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-center justify-center text-white text-lg font-semibold">
                    Kitchen Area
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="flex flex-wrap justify-center lg:justify-start lg:relative lg:left-[13rem] lg:-bottom-[-18rem] relative sm:bottom-[5rem] gap-3 mt-8 lg:mt-0">
            <img
              src={h1}
              alt=""
              className="h-[5rem] w-[5rem] hover:scale-110 transition-transform duration-300 animate-[fadeIn_0.5s_ease-out]"
              style={{ animationDelay: `${0 * 0.2} s` }}
            />
            <img
              src={h2}
              alt=""
              className="h-[5rem] w-[5rem] hover:scale-110 transition-transform duration-300 animate-[fadeIn_0.5s_ease-out]"
              style={{ animationDelay: `${1 * 0.2} s` }}
            />
            <img
              src={h3}
              alt=""
              className="h-[5rem] w-[5rem] hover:scale-110 transition-transform duration-300 animate-[fadeIn_0.5s_ease-out]"
              style={{ animationDelay: `${2 * 0.2} s` }}
            />
            <img
              src={h4}
              alt=""
              className="h-[5rem] w-[5rem] hover:scale-110 transition-transform duration-300 animate-[fadeIn_0.5s_ease-out]"
              style={{ animationDelay: `${3 * 0.2} s` }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default FeeStructure;
